const testimonials = [
  {
    name: "Jennifer M.",
    location: "Woodstock, GA",
    rating: 5,
    text: "We planned a family trip to Jamaica and realized my son's passport had expired. Fast Passport Center sent us a perfect checklist, told us exactly which clerk to visit in Canton, and handled the rest. Got his expedited child passport in 8 days. Amazing service!",
    service: "Child Passport",
  },
  {
    name: "Robert K.",
    location: "Canton, GA",
    rating: 5,
    text: "Business trip to London in 5 days and my passport was expired. I started from my home office in Canton, shipped overnight from the UPS Store in Woodstock, and had my emergency passport in hand in 4 days. Fast Passport Center saved the trip.",
    service: "Emergency Passport",
  },
  {
    name: "Amanda T.",
    location: "Holly Springs, GA",
    rating: 5,
    text: "After my divorce, I needed a name change on my passport before a trip to Mexico. Fast Passport Center guided me through every document, reviewed everything before submission, and got my expedited name change passport back in 12 days. Super smooth.",
    service: "Name Change",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WoodstockTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Woodstock Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Woodstock, Canton, Holly Springs, and north metro Atlanta who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}